import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Card = styled.div`
  border: 1px solid var(--card-border-color);
  background: var(--color-surface);
  border-radius: var(--t-border-radius-xl);
  box-shadow: var(--t-shadow-md);
  position: relative;
  transition: background-color 220ms ease;

  &:hover {
    background: var(--psima-row-hover-bg);
  }

  &:has([data-feedback-popover]) {
    z-index: 2;
  }
`

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const CardHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`

export const CardHeaderTitle = styled.div`
  font-size: var(--t-typography-font-size-base);
  color: var(--color-text);
  font-weight: var(--t-typography-font-weight-medium);
`

export const CardMainContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

export const CardMainLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
`

export const CardMainRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  min-width: 180px;

  @media (max-width: 1100px) {
    min-width: 150px;
  }

  @media (max-width: 1000px) {
    align-items: flex-start;
  }
`

export const CardDescription = styled.div`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-sm);
  line-height: 20px;
  height: 40px;
  max-width: 780px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const TriggerDetailsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 16px;
  background: var(--color-surface-foreground);
  border: 1px solid var(--card-border-color);
  border-radius: 12px;
  min-height: 44px;
  width: fit-content;
  max-width: 100%;
  align-self: flex-start;
`

export const TriggerDetailsLabel = styled.div`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-sm);
`

export const TriggerDetailsDivider = styled.div`
  width: 1px;
  height: 12px;
  background-color: var(--card-border-color);
`

export const RiskMeterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StaticTag = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: var(--t-borders-radius-rounded-md);
  background: var(--psima-osint-tag-bg);
  color: var(--psima-osint-tag-text);
  font-size: var(--t-typography-font-size-xs);
  font-weight: var(--t-typography-font-weight-medium);
`

export const SourceBadgesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`

export const SourceBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  padding: 4px 6px;
  background: var(--psima-source-badge-bg);
  cursor: pointer;
  transition: background-color 150ms ease;

  &:hover {
    background: var(--psima-source-badge-bg-hover);
  }
`

export const SourceCount = styled.span`
  color: var(--psima-source-badge-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-medium);
`

export const SourcesTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
`

export const SourcesTooltipTitle = styled.div`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-xs);
  font-weight: var(--t-typography-font-weight-medium);
  line-height: var(--t-typography-line-height-xs);
`

export const SourcesTooltipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SourceLinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  background: var(--psima-source-badge-bg);
  border: none;
  cursor: pointer;
  color: var(--psima-source-badge-text);
  font-family: inherit;
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-medium);
  text-align: left;
  transition: background-color 150ms ease;

  &:hover {
    background: var(--psima-source-badge-bg-hover);
  }
`

export const SourceLinkLabel = styled.span`
  flex: 1;
  white-space: nowrap;
`

export const BottomDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  height: 24.8px;
`

export const BottomDetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-sm);
`

export const BottomDetailStrong = styled.span`
  font-weight: var(--t-typography-font-weight-semi-bold);
`

export const BottomDetailVerifiedTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: default;
`

export const BottomDetailDivider = styled.div`
  width: 1px;
  height: 12px;
  background-color: var(--card-border-color);
`

export const EmptyAudienceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`

export const EmptyAudienceLabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const EmptyAudienceIconBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px;
  border-radius: var(--t-borders-radius-rounded-md);
  background: var(--psima-source-badge-bg);
`

export const EmptyAudienceLabel = styled.span`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
`

export const EmptyAudienceHint = styled.span`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-sm);
`

export const EmptyAudienceTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 220px;
`

export const EmptyAudienceTooltipTitle = styled.div`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-semi-bold);
`

export const EmptyAudienceTooltipHint = styled.div`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-xs);
`

export const DateDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  @media (max-width: 1000px) {
    align-items: flex-start;
  }
`

export const CreatedAtText = styled.div`
  color: ${({ $unavailable }) => ($unavailable ? 'var(--hint-color)' : 'var(--sub-text-color)')};
  font-size: var(--t-typography-font-size-sm);
`

export const EffectiveUntilText = styled.div`
  color: ${({ $expired }) => ($expired ? 'var(--negative-color)' : 'var(--hint-color)')};
  font-size: var(--t-typography-font-size-xs);
  font-weight: ${({ $expired }) =>
    $expired
      ? 'var(--t-typography-font-weight-medium)'
      : 'var(--t-typography-font-weight-regular)'};
  line-height: var(--t-typography-line-height-xs);
`

export const DepartmentList = styled.span`
  font-weight: var(--t-typography-font-weight-semi-bold);
`

export const MostEffectiveDepartments = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const VisibleDetailsContainer = styled.div`
  padding: 16px;
  min-height: 130px;
  cursor: pointer;
`

export const DetailsContainer = styled.div`
  padding: 30px;
  border-top: 1px solid var(--card-title-border-color);
`

export const DetailsInfoTitle = styled.div`
  font-size: var(--t-typography-font-size-base);
  color: var(--color-text);
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`

export const DetailsInfoSubTitle = styled.div`
  font-size: var(--t-typography-font-size-xs);
  color: var(--sub-text-color);
  margin: 4px 0 0 0px;
`

export const BlueprintContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
`

export const PretextContainer = styled.div`
  padding: 17px 19px;
  border: 1px solid var(--psima-pretext-border);
  border-radius: 18px;
  background: var(--psima-pretext-bg);
  margin-bottom: 10px;
  width: calc(50% - 5px);
`

export const PretextTitle = styled.div`
  position: relative;
  color: var(--psima-pretext-title);
  font-size: var(--t-typography-font-size-base);
  padding-left: 16px;
  font-weight: var(--t-typography-font-weight-semi-bold);
  margin-bottom: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -4px;
    width: 8px;
    height: 8px;
    background-color: var(--psima-pretext-title);
    border-radius: 50%;
  }
`

export const PretextDescription = styled.div`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
`

export const AttackVectorContainer = styled(PretextContainer)`
  border: 1px solid var(--psima-attack-vector-border);
  background: var(--psima-attack-vector-bg);
`

export const AttackVectorTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const AttackVectorSubTitleContainer = styled.div`
  display: flex;
  gap: 2px;
`

export const AttackVectorTitle = styled.div`
  position: relative;
  color: var(--color-text);
  font-size: var(--t-typography-font-size-base);
  padding-left: 16px;
  font-weight: var(--t-typography-font-weight-semi-bold);
  margin-bottom: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -4px;
    width: 8px;
    height: 8px;
    background-color: var(--psima-attack-vector-border);
    border-radius: 50%;
  }
`

export const AttackVectorSubTitle = styled.span`
  font-size: var(--t-typography-font-size-sm);
  color: var(--color-text);
  font-weight: var(--t-typography-font-weight-medium);
  white-space: nowrap;
  margin-right: 4px;
`

export const AttackVectorDescription = styled.div`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
`

export const URLLink = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--t-typography-font-size-xs);
  font-weight: var(--t-typography-font-weight-medium);
  color: var(--psima-source-badge-text);
  border-radius: var(--t-borders-radius-rounded-md);
  background: var(--psima-source-badge-bg);
  padding: var(--t-spacing-0-5) var(--t-spacing-1-5);
  margin-bottom: 8px;
`

export const LocalizationNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: var(--t-borders-radius-rounded-md);
  background: var(--psima-source-badge-bg);
`

export const LocalizationNoteIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 4px;
  border-radius: 6px;
  background: var(--psima-source-badge-bg-hover);
`

export const LocalizationNoteTitle = styled.div`
  margin-bottom: 2px;
  color: var(--psima-source-badge-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-medium);
`

export const TableNameContainer = styled.div`
  display: flex;
  text-transform: capitalize;
  align-items: center;
  gap: 4px;
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);

  ${({ $dimmed }) =>
    $dimmed &&
    `
    > div:first-child {
      opacity: 0.5;
    }
  `}
`

const RISK_SIGNAL_COLORS = {
  vip: {
    bg: 'var(--psima-vip-badge-bg)',
    text: 'var(--psima-vip-badge-text)',
  },
  serialClicker: {
    bg: 'var(--psima-serial-clicker-badge-bg)',
    text: 'var(--psima-serial-clicker-badge-text)',
  },
  untrained: {
    bg: 'var(--psima-untrained-badge-bg)',
    text: 'var(--psima-untrained-badge-text)',
  },
}

export const RiskSignalChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: var(--t-borders-radius-rounded-md);
  background: ${({ $variant }) => RISK_SIGNAL_COLORS[$variant].bg};
  color: ${({ $variant }) => RISK_SIGNAL_COLORS[$variant].text};
`

export const NameWithSignals = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;

  ${({ $dimmed }) => $dimmed && 'opacity: 0.5;'}
`

export const NameText = styled.span`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
`

export const NameTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 160px;
`

export const NameTooltipName = styled.div`
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-semi-bold);
`

export const NameTooltipEmail = styled.div`
  color: var(--sub-text-color);
  font-size: var(--t-typography-font-size-xs);
  word-break: break-all;
`

export const NameTooltipPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

export const NameTooltipPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--t-borders-radius-rounded-md);
  background: ${({ $variant }) => RISK_SIGNAL_COLORS[$variant].bg};
  color: ${({ $variant }) => RISK_SIGNAL_COLORS[$variant].text};
  font-size: var(--t-typography-font-size-xs);
  font-weight: var(--t-typography-font-weight-medium);
  white-space: nowrap;
`

export const VerifiedRowTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`

export const VerifiedIconBadge = styled.span.attrs({
  className: 'psima-verified-icon-badge',
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: var(--t-borders-radius-rounded-md);
  background: var(--psima-source-badge-bg);

  ${({ $variant }) =>
    $variant === 'banner'
      ? `
    padding: 4px;
  `
      : `
    padding: 2px 6px;
  `}
`

const duplicateRowBackground = 'var(--color-surface-foreground)'

const duplicateRowBackgroundStyles = (background) => `
  background: ${background};

  &:nth-child(even) {
    background: ${background};
  }

  &:hover {
    background: ${background};
  }
`

export const ParticipantsTableWrapper = styled.div`
  .psima-duplicate-row {
    ${duplicateRowBackgroundStyles(duplicateRowBackground)}
  }
`

export const TableCheckboxContainer = styled.div`
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const CardHeaderCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`
